import { FdrProductType } from '@hotelplan/supergraph-api';
import { IFdrProductRecommenderComponent } from './fdr-product-recommender.types';

const PRODUCT_RECOMMENDER_WITH_HOTELS_FONT_COLOR = '#000000';
const PRODUCT_RECOMMENDER_WITH_HOTELS_BACKGROUND_COLOR = '#e5ebe0';

export function getProductRecommenderStyles(
  component: IFdrProductRecommenderComponent
): {
  fontColor: string | undefined;
  backgroundColor: string | undefined;
} {
  const containsOnlyHotels =
    Array.isArray(component?.productTypes) &&
    component.productTypes.includes(FdrProductType.Hotel) &&
    component.productTypes.find(i => i !== FdrProductType.Hotel) === undefined;

  return {
    fontColor: containsOnlyHotels
      ? PRODUCT_RECOMMENDER_WITH_HOTELS_FONT_COLOR
      : component?.fontColor,
    backgroundColor: containsOnlyHotels
      ? PRODUCT_RECOMMENDER_WITH_HOTELS_BACKGROUND_COLOR
      : component?.backgroundColor,
  };
}
